import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ListFilter, Search, SquareMinus } from "lucide-react";

import { Button } from "components/ui/Button";
import { Checkbox as CustomCheckbox } from "components/ui/Checkbox";

import styles from "./Filters.module.css";

export const Filters = ({ selectedDoctors, setSelectedDoctors, doctors }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSearch("");
  };

  const filteredDoctors = doctors.filter((d) =>
    `${d.firstName} ${d.lastName}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <Button
        id="sortBy"
        variant="outlineGray"
        endIcon={ListFilter}
        aria-controls={open ? "sortBy" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        Filters
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className={styles.menuItemWrapper}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "12px",
            width: "400px",
            maxHeight: "600px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
          "& .MuiList-root": {
            padding: "0",
            width: "400px",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            flex: 1,
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <div className={styles.menuHeader}>
          <p className={styles.menuHeaderTitle}>Doctors</p>
          <div className={styles.searchWrapper}>
            <Search size={18} className={styles.searchIcon} />
            <input
              autoFocus
              placeholder="Search doctors..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              className={styles.searchInput}
            />
          </div>
        </div>
        <div style={{ overflowY: "auto", flex: 1 }}>
          <MenuItem
            className={`${styles.menuItem} ${styles.menuItemAll}`}
            onClick={() => {
              const allIds = doctors.map((d) => d.id);
              const allSelected = allIds.every((id) => selectedDoctors.includes(id));
              setSelectedDoctors(allSelected ? [] : allIds);
            }}
          >
            <SquareMinus className={styles.menuItemAllIcon} />
            all
          </MenuItem>
          {filteredDoctors.map((doctor) => (
            <label key={doctor.id} style={{ width: "100%" }}>
              <MenuItem className={styles.menuItem}>
                <CustomCheckbox
                  checked={selectedDoctors.includes(doctor.id)}
                  handleChange={(e) => {
                    if (e.target.checked) {
                      setSelectedDoctors((prev) => [...prev, doctor.id]);
                    } else {
                      setSelectedDoctors((prev) =>
                        prev.filter((item) => item !== doctor.id)
                      );
                    }
                  }}
                />
                {doctor.active ? "✅ " : ""}{doctor.firstName} {doctor.lastName}{doctor.staffRole ? ` (${doctor.staffRole.toLowerCase()})` : ""}
              </MenuItem>
            </label>
          ))}
        </div>
      </Menu>
    </div>
  );
};
